import * as Types from '../../../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AcceptCommunityJoinInviteMutationVariables = Types.Exact<{
  inviteId: Types.Scalars['ID']['input'];
}>;


export type AcceptCommunityJoinInviteMutation = { __typename?: 'Mutation', acceptJoinInvite?: { __typename?: 'CommunityGroup', id: string } | null };


export const AcceptCommunityJoinInviteDocument = gql`
    mutation AcceptCommunityJoinInvite($inviteId: ID!) {
  acceptJoinInvite(data: {id: $inviteId}) {
    id
  }
}
    `;
export type AcceptCommunityJoinInviteMutationFn = Apollo.MutationFunction<AcceptCommunityJoinInviteMutation, AcceptCommunityJoinInviteMutationVariables>;

/**
 * __useAcceptCommunityJoinInviteMutation__
 *
 * To run a mutation, you first call `useAcceptCommunityJoinInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCommunityJoinInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCommunityJoinInviteMutation, { data, loading, error }] = useAcceptCommunityJoinInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useAcceptCommunityJoinInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptCommunityJoinInviteMutation, AcceptCommunityJoinInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptCommunityJoinInviteMutation, AcceptCommunityJoinInviteMutationVariables>(AcceptCommunityJoinInviteDocument, options);
      }
export type AcceptCommunityJoinInviteMutationHookResult = ReturnType<typeof useAcceptCommunityJoinInviteMutation>;
export type AcceptCommunityJoinInviteMutationResult = Apollo.MutationResult<AcceptCommunityJoinInviteMutation>;
export type AcceptCommunityJoinInviteMutationOptions = Apollo.BaseMutationOptions<AcceptCommunityJoinInviteMutation, AcceptCommunityJoinInviteMutationVariables>;